export default (params) => ({
  trigger: {
    name: 'content_blocks.product_card.add_to_cart',
    params: params,
  },
  config: {
    schema: {
      item_id: {
        type: 'integer',
      },
      order_type: {
        enum: [
          'purchase',
          'subscription',
          'lease',
        ],
      },
      index: {
        type: 'integer',
      },
      total_indices: {
        type: 'integer',
      },
      correlation_id: {
        type: 'string',
      },
    },
    event: {
      name: 'add_to_cart',
      params: {
        sub_feature: null,
      },
    },
  },
});
